import { render, staticRenderFns } from "./PayOrder.vue?vue&type=template&id=4fc01e92&lang=pug"
import script from "./PayOrder.vue?vue&type=script&lang=js"
export * from "./PayOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports